import '@/theme/partials/_button.scss';

import {
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonIcon,
  IonModal,
  IonToolbar,
} from '@ionic/react';

import CloseIcon from '@/assets/icons/close-outline.svg';

import styles from './Session.module.scss';

interface SessionProps {
  showModal: boolean;
  closeModal: () => void;
  handleLogout: () => void;
}

export default function Session({
  showModal,
  closeModal,
  handleLogout,
}: SessionProps) {
  return (
    <div>
      <IonModal
        isOpen={showModal}
        onDidDismiss={closeModal}
        className={styles.modalSession}

      >
        <IonHeader>
          <IonToolbar className={styles.toolbar}>
            <IonButtons slot="end">
              <IonButton
                onClick={closeModal}
                className={styles.buttonCloseModal}
              >
                <IonIcon md={CloseIcon} className={styles.iconClose} />
              </IonButton>
            </IonButtons>
          </IonToolbar>
        </IonHeader>
        <div className={styles.modalContainer}>
          <div className={styles.modalContent}>
            <h2 className={styles.modalTitle}>¡Vuelve cuando quieras!</h2>

            <IonButtons className={styles.buttons}>
              <IonButton className={styles.buttonClose} onClick={handleLogout}>
                Sí, quiero cerrar sesión
              </IonButton>
              <IonButton className={styles.buttonNoClose} onClick={closeModal}>
                Cancelar
              </IonButton>
            </IonButtons>
            <IonContent className={styles.ionContent} />
          </div>
        </div>
      </IonModal>
    </div>
  );
}
